module.exports = __webpack_public_path__ + "img/game-v1.2e20b0b3.jpg";